import script from "./LinkHandler.vue?vue&type=script&lang=ts&setup=true"
export * from "./LinkHandler.vue?vue&type=script&lang=ts&setup=true"

import "./LinkHandler.vue?vue&type=style&index=0&id=12300fd5&lang=scss&scoped=true"

import exportComponent from "C:\\work\\to-create\\bailing\\yc-bailing-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12300fd5"]])

export default __exports__